export default __webpack_public_path__ + "static/media/logo.79e3357d.svg";